import trimSymbols from '@/shared/utils/trim-symbols';

export default function urlToPlaceName(url: string): string {
  const sanitazedUrl = trimSymbols(url, '-');

  return sanitazedUrl
    .replaceAll('%2F', ' ')
    .replaceAll('/', ' ')
    .split('-')
    .map((word) => {
      if (word.length > 0) {
        return word[0] + word.slice(1);
      }

      return '';
    })
    .join(' ');
}
